document.addEventListener("DOMContentLoaded", function () {
  if (typeof SampleOrder === "undefined") {
    console.error("[sample-order] sample-order-utils.js must be loaded first.");
    return;
  }

  const SCRIPT_VERSION = "2025-05-27-v2";
  const configEl = document.querySelector("#sample-order-config");
  const sampleOrderDataEl = document.querySelector("#sample-order-data");

  const sampleOrderData = (function () {
    if (!sampleOrderDataEl) return null;
    try {
      return JSON.parse(sampleOrderDataEl.textContent);
    } catch (error) {
      console.error("[sample-order] Invalid sample order data JSON:", error);
      return null;
    }
  })();

  const defaultSampleVariantId = sampleOrderData
    ? parseInt(sampleOrderData.defaultVariantId, 10)
    : configEl
      ? parseInt(configEl.getAttribute("data-default-sample-variant-id"), 10)
      : SampleOrder.DEFAULT_SAMPLE_VARIANT_ID;

  const utils = {
    log: function (message, data) {
      console.log("[sample-order] " + message, data);
    },
    fetchCart: function () {
      return fetch(window.Shopify.routes.root + "cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          utils.log("Current cart fetched:", cart);
          return cart;
        })
        .catch(function (error) {
          console.error("Error fetching cart:", error);
          return null;
        });
    },
  };

  const elements = {
    orderSampleButton: document.querySelector("#orderSampleButton"),
    productSkuElement: document.querySelector(".variant-sku"),
    productNameElement: document.querySelector(".product-single__title"),
  };

  const state = {
    sampleVariantId: defaultSampleVariantId,
    maxSamples: (function () {
      const value = configEl
        ? parseInt(configEl.getAttribute("data-quantity-value"), 10)
        : 3;
      return isNaN(value) ? 3 : value;
    })(),
    buttonUpdateDelay: 1500,
  };

  function getSelectedVariantId() {
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]',
    );
    if (variantInput && variantInput.value) {
      return parseInt(variantInput.value, 10);
    }
    return null;
  }

  function getLinkedVariantFromData() {
    if (
      !sampleOrderData ||
      !sampleOrderData.linkedVariants ||
      !sampleOrderData.linkedVariants.length
    ) {
      return null;
    }

    const linkedVariant = sampleOrderData.linkedVariants[0];
    if (!linkedVariant || !linkedVariant.id) {
      return null;
    }

    return parseInt(linkedVariant.id, 10);
  }

  function resolveSampleVariantIdFromMap(variantId) {
    const map = sampleOrderData ? sampleOrderData.byMainVariantId : null;

    if (map && variantId != null && map[String(variantId)] != null) {
      const mappedId = parseInt(map[String(variantId)], 10);
      if (!isNaN(mappedId) && mappedId !== defaultSampleVariantId) {
        return mappedId;
      }
    }

    if (sampleOrderData && sampleOrderData.resolvedVariantId != null) {
      const resolvedId = parseInt(sampleOrderData.resolvedVariantId, 10);
      if (!isNaN(resolvedId) && resolvedId !== defaultSampleVariantId) {
        return resolvedId;
      }
    }

    if (configEl) {
      const configuredId = parseInt(
        configEl.getAttribute("data-sample-variant-id"),
        10,
      );
      if (!isNaN(configuredId) && configuredId !== defaultSampleVariantId) {
        return configuredId;
      }
    }

    return null;
  }

  function syncSampleVariantId(variantId) {
    const linkedVariantId = getLinkedVariantFromData();
    if (linkedVariantId) {
      state.sampleVariantId = linkedVariantId;
    } else {
      const mappedId = resolveSampleVariantIdFromMap(variantId);
      state.sampleVariantId = mappedId || defaultSampleVariantId;
    }

    utils.log("Sample variant resolved:", {
      mainVariantId: variantId,
      sampleVariantId: state.sampleVariantId,
      usesMetafield: state.sampleVariantId !== defaultSampleVariantId,
    });
  }

  function getCurrentProductSku() {
    return elements.productSkuElement
      ? elements.productSkuElement.textContent.trim()
      : null;
  }

  function getCurrentProductName() {
    return elements.productNameElement
      ? elements.productNameElement.textContent.trim()
      : null;
  }

  function getMainSku() {
    const sku = getCurrentProductSku();
    return sku || null;
  }

  const coreFunctions = {
    ensureSampleVariantResolved: function () {
      const mainVariantId = getSelectedVariantId();

      function finish() {
        utils.log("Final sample variant for cart:", {
          scriptVersion: SCRIPT_VERSION,
          mainVariantId: mainVariantId,
          sampleVariantId: state.sampleVariantId,
          defaultSampleVariantId: defaultSampleVariantId,
          sampleOrderData: sampleOrderData,
        });
      }

      const linkedVariantId = getLinkedVariantFromData();
      if (linkedVariantId) {
        state.sampleVariantId = linkedVariantId;
        finish();
        return Promise.resolve();
      }

      syncSampleVariantId(mainVariantId);

      if (state.sampleVariantId !== defaultSampleVariantId) {
        finish();
        return Promise.resolve();
      }

      if (!sampleOrderData || !sampleOrderData.metafieldPresent) {
        finish();
        return Promise.resolve();
      }

      const rawValue = sampleOrderData.metafieldRaw || "";
      const variantFromGid = SampleOrder.parseVariantIdFromGid(rawValue);
      if (variantFromGid) {
        state.sampleVariantId = variantFromGid;
        finish();
        return Promise.resolve();
      }

      const handle = sampleOrderData.linkedProductHandle;
      if (!handle) {
        console.warn(
          "[sample-order] sample_product metafield is present but no linked product handle or variant could be resolved.",
          sampleOrderData,
        );
        finish();
        return Promise.resolve();
      }

      return fetch(
        window.Shopify.routes.root +
          "products/" +
          encodeURIComponent(handle) +
          ".js",
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Product fetch failed with status " + response.status);
          }
          return response.json();
        })
        .then(function (product) {
          if (product && product.variants && product.variants.length) {
            const variant =
              product.variants.find(function (item) {
                return item.available;
              }) || product.variants[0];

            if (variant && variant.id) {
              state.sampleVariantId = variant.id;
              utils.log("Resolved sample variant from linked product handle:", {
                handle: handle,
                sampleVariantId: state.sampleVariantId,
                samplePrice: variant.price,
              });
            }
          }
          finish();
        })
        .catch(function (error) {
          console.error("[sample-order] Linked product handle lookup failed:", error);
          finish();
        });
    },

    addSampleToCart: function () {
      const mainSku = getMainSku();
      const mainName = getCurrentProductName();

      if (!mainSku || !mainName) {
        alert("Unable to add sample. Please select a product variant.");
        return;
      }

      coreFunctions.ensureSampleVariantResolved().then(function () {
        if (
          sampleOrderData &&
          sampleOrderData.metafieldPresent &&
          state.sampleVariantId === defaultSampleVariantId
        ) {
          console.warn(
            "[sample-order] sample_product metafield is set but still using the default sample variant.",
            sampleOrderData,
          );
        }

        utils.fetchCart().then(function (cart) {
          if (!cart) {
            utils.log("Failed to fetch cart. Cannot proceed with sample order.");
            return;
          }

          const sampleItem = SampleOrder.findSampleLineForVariant(
            cart,
            state.sampleVariantId,
          );
          const totalSamples = SampleOrder.getTotalSampleCount(cart);

          if (sampleItem && sampleItem.properties[mainSku]) {
            coreFunctions.removeSampleFromCart();
            return;
          }

          if (totalSamples >= state.maxSamples) {
            alert("You have reached the maximum number of samples allowed.");
            return;
          }

          let endpoint;
          let method;
          let body;

          if (sampleItem) {
            const updatedProperties = SampleOrder.buildSampleProperties(
              sampleItem.properties,
              mainSku,
              mainName,
            );

            endpoint = window.Shopify.routes.root + "cart/change.js";
            method = "POST";
            body = JSON.stringify({
              id: sampleItem.key,
              quantity: 1,
              properties: updatedProperties,
            });

            utils.log("Updating existing sample in cart:", {
              itemKey: sampleItem.key,
              sampleVariantId: state.sampleVariantId,
              updatedProperties: updatedProperties,
            });
          } else {
            endpoint = window.Shopify.routes.root + "cart/add.js";
            method = "POST";
            body = JSON.stringify({
              items: [
                {
                  id: state.sampleVariantId,
                  quantity: 1,
                  properties: SampleOrder.buildSampleProperties(
                    null,
                    mainSku,
                    mainName,
                  ),
                },
              ],
            });

            utils.log("Adding new sample to cart:", {
              scriptVersion: SCRIPT_VERSION,
              sampleVariantId: state.sampleVariantId,
              mainSku: mainSku,
              mainName: mainName,
            });
          }

          fetch(endpoint, {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: body,
          })
            .then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) {
                  throw data;
                }
                return data;
              });
            })
            .then(function (data) {
              utils.log("Cart updated successfully:", data);
              SampleOrder.refreshThemeCart();
              coreFunctions.updateButtonState(true);
            })
            .catch(function (error) {
              console.error("Error updating cart:", error);
            });
        });
      });
    },

    removeSampleFromCart: function () {
      coreFunctions.ensureSampleVariantResolved().then(function () {
        const mainSku = getMainSku();

        if (!mainSku) return;

        utils.fetchCart().then(function (cart) {
          if (!cart) {
            utils.log("Failed to fetch cart. Cannot proceed with sample removal.");
            return;
          }

          const sampleItem = SampleOrder.findSampleLineForVariant(
            cart,
            state.sampleVariantId,
          );

          if (!sampleItem || !sampleItem.properties[mainSku]) return;

          const updatedProperties = Object.assign({}, sampleItem.properties);
          delete updatedProperties[mainSku];

          let body;

          if (SampleOrder.propertiesOnlyMarkerLeft(updatedProperties)) {
            body = JSON.stringify({
              id: sampleItem.key,
              quantity: 0,
            });
          } else {
            body = JSON.stringify({
              id: sampleItem.key,
              quantity: 1,
              properties: updatedProperties,
            });
          }

          fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: body,
          })
            .then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) {
                  throw data;
                }
                return data;
              });
            })
            .then(function (data) {
              utils.log("Sample updated or removed from cart:", data);
              SampleOrder.refreshThemeCart();
              coreFunctions.updateButtonState();
            })
            .catch(function (error) {
              console.error("Error updating or removing sample from cart:", error);
            });
        });
      });
    },

    updateButtonState: function (justAdded) {
      if (!elements.orderSampleButton) return;

      utils.fetchCart().then(function (cart) {
        if (!cart) {
          utils.log("Failed to fetch cart. Cannot update button state.");
          return;
        }

        const mainSku = getMainSku();
        const sampleItem = SampleOrder.findSampleLineForVariant(
          cart,
          state.sampleVariantId,
        );
        const totalSamples = SampleOrder.getTotalSampleCount(cart);
        const remainingSamples = state.maxSamples - totalSamples;

        let buttonSpan = elements.orderSampleButton.querySelector("span");
        if (!buttonSpan) {
          buttonSpan = document.createElement("span");
          elements.orderSampleButton.appendChild(buttonSpan);
        }

        const updateButtonText = function (text) {
          buttonSpan.textContent = text;
        };

        elements.orderSampleButton.disabled = false;

        if (sampleItem && mainSku && sampleItem.properties[mainSku]) {
          if (justAdded) {
            updateButtonText(
              remainingSamples +
                "/" +
                state.maxSamples +
                " samples left",
            );
            setTimeout(function () {
              updateButtonText("Remove sample");
            }, state.buttonUpdateDelay);
          } else {
            updateButtonText("Remove sample");
          }
        } else if (totalSamples >= state.maxSamples) {
          updateButtonText("Sample limit reached");
          elements.orderSampleButton.disabled = true;
        } else if (remainingSamples > 0) {
          updateButtonText(
            "Order sample (" +
              remainingSamples +
              "/" +
              state.maxSamples +
              " left)",
          );
        } else {
          updateButtonText(
            "Order sample (" +
              state.maxSamples +
              "/" +
              state.maxSamples +
              " left)",
          );
        }
      });
    },
  };

  function setupEventListeners() {
    if (elements.orderSampleButton) {
      elements.orderSampleButton.addEventListener("click", function (e) {
        e.preventDefault();
        coreFunctions.addSampleToCart();
      });
    }

    document.addEventListener("variantChange", function (event) {
      const variantId =
        event.detail && event.detail.variant
          ? event.detail.variant.id
          : getSelectedVariantId();
      syncSampleVariantId(variantId);
      coreFunctions.updateButtonState();
    });
  }

  function init() {
    setupEventListeners();
    utils.log("Sample order initialized", {
      scriptVersion: SCRIPT_VERSION,
      sampleOrderData: sampleOrderData,
    });
    coreFunctions.ensureSampleVariantResolved().then(function () {
      coreFunctions.updateButtonState();
    });
  }

  init();
});
